export { default as Slide1 } from './slide1.component.js';
export { default as Slide2 } from './slide2.component.js';
export { default as Slide3 } from './slide3.component.js';
export { default as Slide4 } from './slide4.component.js';
export { default as Slide5 } from './slide5.component.js';
export { default as Slide6 } from './slide6.component.js';
export { default as Slide7 } from './slide7.component.js';
export { default as Slide8 } from './slide8.component.js';



// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/index.js